(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8],{

/***/ 33736:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/typefaces",
      function () {
        return __webpack_require__(71522);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _components_global_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(232);
/* harmony import */ var _lib_paths__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47475);
/* harmony import */ var _storyblok_components_DynamicComponent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79426);
/* harmony import */ var _global_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80772);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48941);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var Error_404 = function(param) {
    var mainTitle = param.mainTitle, secondaryTitle = param.secondaryTitle, buttonText = param.buttonText, image = param.image;
    var paths = (0,_lib_paths__WEBPACK_IMPORTED_MODULE_3__/* .usePaths */ ._)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
            id: "main",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_global_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .r, {
                rowAlign: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Column */ .s, {
                        sm: 12,
                        md: 12,
                        lg: 5,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header),
                                    children: mainTitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                                    children: secondaryTitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button),
                                    href: paths.$url(),
                                    children: buttonText
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Column */ .s, {
                        sm: 12,
                        md: 4,
                        lg: 1
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Column */ .s, {
                        sm: 12,
                        md: 4,
                        lg: 6,
                        children: image && image.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().containerImage),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_components_DynamicComponent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                blok: image === null || image === void 0 ? void 0 : image[0]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Error_404);


/***/ }),

/***/ 29458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_404; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/404/404.tsx
var _404 = __webpack_require__(57207);
// EXTERNAL MODULE: ./components/global/Footer/index.ts + 4 modules
var Footer = __webpack_require__(6695);
// EXTERNAL MODULE: ./components/global/Header/index.tsx + 7 modules
var Header = __webpack_require__(50794);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.5.0_ycv3wu2xpvbe7yzamsmed7oh2q/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(59370);
;// CONCATENATED MODULE: ./components/seo/NotFoundSeo.tsx


var NotFoundSeo = function() {
    var title = "Not found - Colophon Foundry";
    var description = "Page not found.";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: title,
        description: description,
        openGraph: {
            title: title,
            description: description,
            images: [
                {
                    url: "https://og-image.vercel.app/React%20Storefront.png?theme=light&md=1&fontSize=100px&images=https%3A%2F%2Fassets.vercel.com%2Fimage%2Fupload%2Ffront%2Fassets%2Fdesign%2Fvercel-triangle-black.svg&images=https%3A%2F%2Fsaleor.io%2Fstatic%2Flogo-ad1b99aa7c6f5acf58a61640af760cfd.svg",
                    alt: "Colophon Foundry hero image"
                }
            ],
            site_name: "Colophon Foundry"
        }
    });
};
/* harmony default export */ var seo_NotFoundSeo = (NotFoundSeo);

// EXTERNAL MODULE: ./lib/storyblok/storyblokNavLinks.ts
var storyblokNavLinks = __webpack_require__(83176);
;// CONCATENATED MODULE: ./pages/404.tsx







var Custom404 = function(param) {
    var story = param.story;
    var ref = story === null || story === void 0 ? void 0 : story.content, mainTitle = ref.mainTitle, secondaryTitle = ref.secondaryTitle, buttonText = ref.buttonText, image = ref.image;
    var globalLinks = (0,storyblokNavLinks/* getStoryBlokNavLinks */.G)(story);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_NotFoundSeo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                navigation: globalLinks
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_404/* default */.Z, {
                mainTitle: mainTitle,
                secondaryTitle: secondaryTitle,
                buttonText: buttonText,
                image: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.ZP, {
                navigation: globalLinks.footerLinks,
                theme: "grey-light"
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages_404 = (Custom404);


/***/ }),

/***/ 71522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ typefaces; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./pages/404.tsx + 1 modules
var _404 = __webpack_require__(29458);
// EXTERNAL MODULE: ./storyblok/index.ts + 2 modules
var storyblok = __webpack_require__(47659);
// EXTERNAL MODULE: ./components/index.ts + 27 modules
var components = __webpack_require__(94842);
// EXTERNAL MODULE: ./components/global/Footer/index.ts + 4 modules
var Footer = __webpack_require__(6695);
// EXTERNAL MODULE: ./components/global/Header/index.tsx + 7 modules
var Header = __webpack_require__(50794);
// EXTERNAL MODULE: ./components/seo/BaseSeo.tsx
var BaseSeo = __webpack_require__(57758);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(12902);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./components/global/NoResults/index.tsx + 1 modules
var NoResults = __webpack_require__(36551);
// EXTERNAL MODULE: ./components/global/Pagination.tsx
var Pagination = __webpack_require__(1776);
// EXTERNAL MODULE: ./components/providers/RegionsProvider.tsx + 10 modules
var RegionsProvider = __webpack_require__(60239);
// EXTERNAL MODULE: ./lib/datalayer/checkout.ts
var checkout = __webpack_require__(74198);
// EXTERNAL MODULE: ./saleor/api.tsx + 4 modules
var api = __webpack_require__(67062);
// EXTERNAL MODULE: ./components/translations.ts + 2 modules
var translations = __webpack_require__(33525);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/global/Checkbox/index.tsx
var Checkbox = __webpack_require__(98188);
// EXTERNAL MODULE: ./components/global/CustomFont/index.tsx
var CustomFont = __webpack_require__(34316);
// EXTERNAL MODULE: ./components/global/FontLoader/index.tsx
var FontLoader = __webpack_require__(53409);
;// CONCATENATED MODULE: ./components/typeface/TypefaceCard/FontStamp.tsx

var FontStamp = function(param) {
    var productStampAttributeValue = param.productStampAttributeValue, styles = param.styles;
    return productStampAttributeValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: styles === null || styles === void 0 ? void 0 : styles.TypefaceCard__Stamp,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: styles === null || styles === void 0 ? void 0 : styles.TypefaceCard__StampInner,
            children: productStampAttributeValue
        })
    }) : null;
};
/* harmony default export */ var TypefaceCard_FontStamp = (FontStamp);
var productStampAttribute = function(attributes) {
    var ref1;
    var stampAttribute = attributes.find(function(attribute) {
        var ref;
        return (attribute === null || attribute === void 0 ? void 0 : (ref = attribute.attribute) === null || ref === void 0 ? void 0 : ref.slug) === "stamp";
    });
    return (stampAttribute === null || stampAttribute === void 0 ? void 0 : stampAttribute.values.length) > 0 ? (ref1 = stampAttribute.values[0]) === null || ref1 === void 0 ? void 0 : ref1.name : "";
};
var productStampColourScheme = function(attributes) {
    var colourAttribute = attributes.find(function(attribute) {
        var ref;
        return (attribute === null || attribute === void 0 ? void 0 : (ref = attribute.attribute) === null || ref === void 0 ? void 0 : ref.slug) === "stamp-colours";
    });
    if ((colourAttribute === null || colourAttribute === void 0 ? void 0 : colourAttribute.values.length) > 0) {
        var ref2;
        var coloursArray = (ref2 = colourAttribute.values[0]) === null || ref2 === void 0 ? void 0 : ref2.name.split(",");
        // Prevent non-hex code data
        var hexRegex = /^#[0-9A-F]{6}$/i;
        coloursArray = coloursArray.filter(function(colour) {
            return hexRegex.test(colour);
        });
        var arrayLength = coloursArray.length;
        if (arrayLength !== 2) return [];
        return coloursArray;
    }
    return [];
};

// EXTERNAL MODULE: ./lib/fonts/fontVersion.ts
var fontVersion = __webpack_require__(16270);
// EXTERNAL MODULE: ./lib/fonts/s3FontPath.ts
var s3FontPath = __webpack_require__(57189);
// EXTERNAL MODULE: ./lib/paths.ts + 1 modules
var lib_paths = __webpack_require__(47475);
// EXTERNAL MODULE: ./lib/productHelpers.tsx
var productHelpers = __webpack_require__(11603);
;// CONCATENATED MODULE: ./lib/translations.ts
function translate(obj, key) {
    var ref;
    // TODO: better types
    // @ts-ignore
    return ((ref = obj.translation) === null || ref === void 0 ? void 0 : ref[key]) || obj[key];
}

// EXTERNAL MODULE: ./components/typeface/TypefaceCard/TypefaceCard.module.scss
var TypefaceCard_module = __webpack_require__(88102);
var TypefaceCard_module_default = /*#__PURE__*/__webpack_require__.n(TypefaceCard_module);
;// CONCATENATED MODULE: ./components/typeface/TypefaceCard/TypefaceCard.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
















var TypefaceCard = function(param) {
    var product = param.product, customText = param.customText, toggleCompareProduct = param.toggleCompareProduct, checked = param.checked;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var paths = (0,lib_paths/* usePaths */._)();
    var formatPrice = (0,RegionsProvider/* useRegions */.eH)().formatPrice;
    var productType = product.productType, attributes = product.attributes;
    var productTypeSlug = productType.slug;
    var fontProduct = productTypeSlug === "font-family";
    var fontDisplayName = (0,productHelpers/* getFontDisplayName */.Ow)({
        name: product.name,
        metadata: product.metadata
    });
    var fontSizeAdjust = (0,productHelpers/* getProductFontSizeAdjust */.tM)(product);
    var priceDisplay = formatPrice((ref = product.pricing) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRange) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.start) === null || ref2 === void 0 ? void 0 : ref2.net);
    if (((ref3 = product.pricing) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.priceRange) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.start) === null || ref5 === void 0 ? void 0 : ref5.net.amount) !== ((ref6 = product.pricing) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.priceRange) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.stop) === null || ref8 === void 0 ? void 0 : ref8.net.amount)) {
        priceDisplay = "from " + priceDisplay;
    }
    var imageStyle = {};
    if (!!((ref9 = product.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url)) {
        var ref11;
        imageStyle.backgroundImage = "url(".concat((ref11 = product.thumbnail) === null || ref11 === void 0 ? void 0 : ref11.url, ")");
        imageStyle.backgroundSize = "auto";
        imageStyle.backgroundRepeat = "no-repeat";
        imageStyle.backgroundPosition = "center";
    }
    var productMetaData = (0,productHelpers/* getMetaDataValueByKey */.jN)({
        item: product
    });
    var styleCountMeta = productMetaData("styleCount");
    var weightCountMeta = productMetaData("weightCount");
    var stylesPro = product.variants.filter(function(variant) {
        return !(0,productHelpers/* isFamilyVariant */.S5)(variant) && !(0,productHelpers/* isVariableFont */.bc)(variant) && (0,fontVersion/* fontIsPro */.j)(variant);
    });
    var stylesStd = product.variants.filter(function(variant) {
        return !(0,productHelpers/* isFamilyVariant */.S5)(variant) && !(0,productHelpers/* isVariableFont */.bc)(variant) && !(0,fontVersion/* fontIsPro */.j)(variant);
    });
    var stylesProOrStd = stylesPro.length >= stylesStd.length ? stylesPro : stylesStd;
    var styleCount = styleCountMeta || stylesProOrStd.length;
    var productStampAttributeValue = productStampAttribute(attributes);
    var productStampColours = productStampColourScheme(attributes);
    var style = {
        "--stamp-bg": productStampColours[0] || null,
        "--stamp-fg": productStampColours[1] || null
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: productStampColours.length === 2 ? style : {},
        className: (0,clsx_m/* default */.Z)((TypefaceCard_module_default()).TypefaceCardContainer),
        children: [
            fontProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TypefaceCard_module_default()).compare,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    onChange: function() {
                        toggleCompareProduct(product.id);
                    },
                    isChecked: checked,
                    name: "compare",
                    id: product.id,
                    value: product.id,
                    label: "Compare",
                    hideLabel: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: paths.typefaces._slug(product.slug).$url(),
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    // add 'select_item' to the dataLayer
                    onClick: function() {
                        checkout/* default.selectItem */.Z.selectItem(product);
                    },
                    className: (TypefaceCard_module_default()).TypefaceCard,
                    children: [
                        !fontProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: imageStyle,
                            children: !!((ref10 = product.pricing) === null || ref10 === void 0 ? void 0 : ref10.onSale) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Sale"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                !fontProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: fontDisplayName
                                }),
                                fontProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)((TypefaceCard_module_default()).TypefaceCard__Details, (TypefaceCard_module_default())["TypefaceCard__Details--single"]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: translate(product, "name")
                                    })
                                }),
                                fontProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoader/* default */.Z, {
                                            fullPath: true,
                                            fontDisplay: "fallback",
                                            fontName: product.name,
                                            s3Path: (0,s3FontPath/* generateS3PathFromVariants */.q0)(product.slug, product.variants, attributes)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFont/* default */.Z, {
                                            fontName: product.name,
                                            uuid: product.id.replace("=", ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: (TypefaceCard_module_default()).TypefaceCard__FontTitle,
                                                style: _objectSpread({}, fontSizeAdjust && {
                                                    "--font-size-adjust": fontSizeAdjust
                                                }),
                                                children: customText ? customText : fontDisplayName.replace(/<br\s*\/?>/gi, "\n")
                                            })
                                        })
                                    ]
                                }),
                                fontProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)((TypefaceCard_module_default()).TypefaceCard__Details, (_obj = {}, _defineProperty(_obj, "".concat((TypefaceCard_module_default())["TypefaceCard__Details--multi"]), weightCountMeta !== undefined), _defineProperty(_obj, "".concat((TypefaceCard_module_default())["TypefaceCard__Details--single"]), weightCountMeta === undefined), _obj)),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypefaceCard_FontStamp, {
                                            productStampAttributeValue: productStampAttributeValue,
                                            styles: (TypefaceCard_module_default())
                                        }),
                                        weightCountMeta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "".concat(weightCountMeta, " weights")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "".concat(styleCount, " styles")
                                        })
                                    ]
                                }),
                                !fontProduct && !!product.category && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: translate(product.category, "name")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: priceDisplay
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var TypefaceCard_TypefaceCard = (TypefaceCard);

;// CONCATENATED MODULE: ./components/typeface/helpers/typefaceCollectionHelpers.tsx

var TYPEFACES_FILTERING_CATEGORIES = [
    {
        id: "name:asc",
        name: "Name A-Z",
        value: {
            field: "NAME",
            direction: "ASC"
        }
    },
    {
        id: "name:desc",
        name: "Name Z-A",
        value: {
            field: "NAME",
            direction: "DESC"
        }
    },
    {
        id: "first_published_at:desc",
        name: "Latest (Descending)",
        customContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    textAlign: "left",
                    flexGrow: 1
                },
                children: [
                    "Latest ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "charcoal",
                        children: "(Descending)"
                    })
                ]
            })
        }),
        value: {
            field: "PUBLISHED_AT",
            direction: "DESC"
        }
    },
    {
        id: "content.popularity:desc",
        name: "Most Popular",
        value: {
            field: "RATING",
            direction: "DESC"
        }
    },
    {
        id: "content.hiddenGem",
        name: "Hidden Gems",
        value: {
            field: "RATING",
            direction: "ASC"
        }
    }
];

// EXTERNAL MODULE: ./components/typeface/TypefaceCollection.module.scss
var TypefaceCollection_module = __webpack_require__(53643);
var TypefaceCollection_module_default = /*#__PURE__*/__webpack_require__.n(TypefaceCollection_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./components/global/Dropdown/index.tsx + 3 modules
var Dropdown = __webpack_require__(58677);
// EXTERNAL MODULE: ./components/global/MultiDropdown/MultiDropdown.tsx + 4 modules
var MultiDropdown = __webpack_require__(52004);
;// CONCATENATED MODULE: ./lib/filters.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function filters_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filters_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filters_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var applyFilters = function(param) {
    var filters = param.filters, type = param.type, value = param.value, _attribute = param.attribute, attribute = _attribute === void 0 ? null : _attribute, callback = param.callback;
    var newFilters = {};
    switch(type){
        case "attribute":
            var newAttributeArray;
            var _attributes = filters.attributes, attributes = _attributes === void 0 ? [] : _attributes;
            var attributeInFilters = attributes.some(function(filterAttribute) {
                return filterAttribute.slug === attribute.node.slug;
            });
            if (attributeInFilters) {
                newAttributeArray = attributes.map(function(filterAttribute) {
                    if (filterAttribute.slug === attribute.node.slug) {
                        return value.id === 0 ? null : filters_objectSpread({}, filterAttribute, {
                            values: [
                                value.id
                            ]
                        });
                    }
                    return filterAttribute;
                }).filter(function(filterAttribute) {
                    return filterAttribute !== null;
                });
            } else {
                newAttributeArray = _toConsumableArray(attributes).concat([
                    {
                        slug: attribute.node.slug,
                        values: [
                            value.id
                        ]
                    }
                ]);
            }
            newFilters = filters_objectSpread({}, filters, {
                attributes: newAttributeArray
            });
            break;
        case "category":
            newFilters = filters_objectSpread({}, filters, {
                categories: [
                    value.id
                ]
            });
            break;
        case "search":
            newFilters = filters_objectSpread({}, filters, {
                search: value
            });
            break;
        default:
            break;
    }
    callback(newFilters);
};

// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/product/SearchBox/SearchBox.module.scss
var SearchBox_module = __webpack_require__(39174);
var SearchBox_module_default = /*#__PURE__*/__webpack_require__.n(SearchBox_module);
;// CONCATENATED MODULE: ./components/product/SearchBox/SearchBox.tsx
function SearchBox_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SearchBox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || SearchBox_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function SearchBox_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SearchBox_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SearchBox_arrayLikeToArray(o, minLen);
}






var SearchBox = function(param) {
    var state = param.state, disabled = param.disabled, onSearch = param.onSearch, _hasSeparator = param.hasSeparator, hasSeparator = _hasSeparator === void 0 ? true : _hasSeparator;
    var _state = _slicedToArray(state, 2), search = _state[0], setSearch = _state[1];
    var ref = (0,react.useState)(null), changed = ref[0], setChanged = ref[1];
    (0,react.useEffect)(function() {
        if (changed) {
            var timer = setTimeout(function() {
                setChanged(false);
                onSearch({
                    value: search
                });
            }, 800);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        search,
        changed
    ]);
    var clear = function() {
        setSearch("");
        onSearch({
            value: ""
        });
        setChanged(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((SearchBox_module_default()).search, disabled && (SearchBox_module_default()).disabled),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(SearchBox_defineProperty({}, (SearchBox_module_default()).icon, hasSeparator)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    width: "16",
                    height: "16",
                    iconName: "search"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                placeholder: "Search by family name",
                className: (SearchBox_module_default()).input,
                value: search,
                onChange: function(ev) {
                    setSearch(ev.target.value);
                    setChanged(true);
                },
                disabled: disabled,
                "aria-label": "Search"
            }),
            search && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                callBack: clear,
                variant: "ghost",
                title: "clear search",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    width: "16",
                    height: "16",
                    iconName: "close"
                })
            })
        ]
    });
};
/* harmony default export */ var SearchBox_SearchBox = (SearchBox);

;// CONCATENATED MODULE: ./components/product/SearchBox/index.tsx

/* harmony default export */ var product_SearchBox = (SearchBox_SearchBox);

// EXTERNAL MODULE: ./components/typeface/TypefaceHeader/TypefaceHeader.module.scss
var TypefaceHeader_module = __webpack_require__(6887);
var TypefaceHeader_module_default = /*#__PURE__*/__webpack_require__.n(TypefaceHeader_module);
;// CONCATENATED MODULE: ./components/typeface/TypefaceHeader/TypefaceHeader.tsx
function TypefaceHeader_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TypefaceHeader_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TypefaceHeader_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return TypefaceHeader_arrayLikeToArray(arr);
}
function TypefaceHeader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TypefaceHeader_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function TypefaceHeader_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function TypefaceHeader_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TypefaceHeader_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TypefaceHeader_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TypefaceHeader_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TypefaceHeader_slicedToArray(arr, i) {
    return TypefaceHeader_arrayWithHoles(arr) || TypefaceHeader_iterableToArrayLimit(arr, i) || TypefaceHeader_unsupportedIterableToArray(arr, i) || TypefaceHeader_nonIterableRest();
}
function TypefaceHeader_toConsumableArray(arr) {
    return TypefaceHeader_arrayWithoutHoles(arr) || TypefaceHeader_iterableToArray(arr) || TypefaceHeader_unsupportedIterableToArray(arr) || TypefaceHeader_nonIterableSpread();
}
function TypefaceHeader_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TypefaceHeader_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TypefaceHeader_arrayLikeToArray(o, minLen);
}









function TypefaceHeader(param1) {
    var attributes = param1.attributes, searchState = param1.searchState, isComparing = param1.isComparing, categoryId = param1.categoryId, childCategories = param1.childCategories, filters = param1.filters, setFilters = param1.setFilters, sort = param1.sort, setSort = param1.setSort;
    var _searchState = TypefaceHeader_slicedToArray(searchState, 2), search = _searchState[0], setSearch = _searchState[1];
    var ref4 = (0,react.useState)([]), languageOptions = ref4[0], setLanguageOptions = ref4[1];
    var ref1 = (0,react.useState)([]), selectedFilters = ref1[0], setSelectedFilters = ref1[1];
    var ref2 = (0,react.useState)([]), selectedFiltersIds = ref2[0], setSelectedFiltersIds = ref2[1];
    var router = (0,next_router.useRouter)();
    var params =  true ? new URLSearchParams(window === null || window === void 0 ? void 0 : window.location.search) : 0;
    var sortParams = params === null || params === void 0 ? void 0 : params.get("sort");
    var languagesParams = params === null || params === void 0 ? void 0 : params.get("languages");
    var classificationsParams = params === null || params === void 0 ? void 0 : params.get("classifications");
    var searchParams = params === null || params === void 0 ? void 0 : params.get("search");
    var TYPEFACES_MULTI_MENU_ITEMS = (0,react.useMemo)(function() {
        return [
            {
                title: "Languages",
                noneButtonTitle: "None",
                allButtonTitle: "All",
                component: "menuItem",
                items: languageOptions
            },
            {
                title: "Classification",
                noneButtonTitle: "None",
                allButtonTitle: "All",
                component: "menuItem",
                items: TypefaceHeader_toConsumableArray(childCategories.map(function(category) {
                    return {
                        id: category.node.id,
                        name: category.node.name
                    };
                }))
            }
        ];
    }, [
        childCategories,
        languageOptions
    ]);
    var setMenuFilters = function(filter, action) {
        var _selectedFilters = [];
        if (Array.isArray(filter)) {
            var _filterIds = filter.map(function(e) {
                return e.id;
            });
            // add method
            if (action === "add") {
                var __selectedFilters;
                _selectedFilters = selectedFilters.filter(function(f) {
                    return !_filterIds.includes(f.id);
                });
                (__selectedFilters = _selectedFilters).push.apply(__selectedFilters, TypefaceHeader_toConsumableArray(filter));
            }
            // remove method
            if (action === "remove") {
                _selectedFilters = selectedFilters.filter(function(f) {
                    return !_filterIds.includes(f.id);
                });
            }
        } else {
            _selectedFilters = selectedFilters.filter(function(e) {
                return e.id !== filter.id;
            });
            if (!selectedFiltersIds.includes(filter.id)) _selectedFilters.push(filter);
        }
        var _selectedFiltersIds = _selectedFilters.map(function(e) {
            return e.id;
        });
        setSelectedFilters(_selectedFilters);
        setSelectedFiltersIds(_selectedFiltersIds);
        // getFilteredData(_selectedFiltersIds);
        // Check if the filter is attribute or category
        var attributeFilters = _selectedFiltersIds.filter(function(id) {
            return !id.endsWith("=");
        });
        var categoryFilters = _selectedFiltersIds.filter(function(id) {
            return id.endsWith("=");
        });
        router.push({
            pathname: "/typefaces",
            query: TypefaceHeader_objectSpread({}, sortParams && {
                sort: sortParams
            }, attributeFilters.length > 0 && {
                languages: TypefaceHeader_toConsumableArray(attributeFilters).join(",")
            }, categoryFilters.length > 0 && {
                classifications: TypefaceHeader_toConsumableArray(categoryFilters).join(",")
            }, searchParams && {
                search: searchParams
            })
        }, undefined, {
            shallow: true
        });
    };
    (0,react.useEffect)(function() {
        attributes.map(function(attribute) {
            var ref, ref3;
            var attributeOptions = TypefaceHeader_toConsumableArray(attribute === null || attribute === void 0 ? void 0 : (ref = attribute.node) === null || ref === void 0 ? void 0 : (ref3 = ref.choices) === null || ref3 === void 0 ? void 0 : ref3.edges.map(function(attributeOption) {
                return {
                    name: attributeOption.node.name,
                    id: attributeOption.node.slug
                };
            }));
            setLanguageOptions(attributeOptions);
            return attribute;
        });
    }, [
        attributes
    ]);
    (0,react.useEffect)(function() {
        if (params) {
            var ref, ref5;
            setFilters(TypefaceHeader_objectSpread({}, filters, {
                attributes: languagesParams ? [
                    {
                        slug: attributes === null || attributes === void 0 ? void 0 : (ref = attributes[0]) === null || ref === void 0 ? void 0 : (ref5 = ref.node) === null || ref5 === void 0 ? void 0 : ref5.slug,
                        values: languagesParams.split(",")
                    }
                ] : null,
                categories: classificationsParams ? classificationsParams.split(",") : [
                    categoryId
                ]
            }, searchParams && {
                search: searchParams
            }));
            if (sortParams) {
                var ref6;
                setSort((ref6 = TYPEFACES_FILTERING_CATEGORIES === null || TYPEFACES_FILTERING_CATEGORIES === void 0 ? void 0 : TYPEFACES_FILTERING_CATEGORIES.find(function(item) {
                    var sortParamsArray = sortParams.split(":").map(function(param) {
                        return param.toUpperCase();
                    });
                    return sortParamsArray[0] === item.value.field && sortParamsArray[1] === item.value.direction;
                })) === null || ref6 === void 0 ? void 0 : ref6.value);
            }
            if (searchParams) {
                setSearch(searchParams);
            }
        }
    }, [
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        setSelectedFilters(TypefaceHeader_toConsumableArray(languagesParams ? TYPEFACES_MULTI_MENU_ITEMS[0].items.filter(function(item) {
            return languagesParams.split(",").includes(item.id);
        }) : []).concat(TypefaceHeader_toConsumableArray(classificationsParams ? TYPEFACES_MULTI_MENU_ITEMS[1].items.filter(function(item) {
            return classificationsParams.split(",").includes(item.id);
        }) : [])));
        setSelectedFiltersIds(TypefaceHeader_toConsumableArray(languagesParams ? languagesParams.split(",") : []).concat(TypefaceHeader_toConsumableArray(classificationsParams ? classificationsParams.split(",") : [])));
    }, [
        languagesParams,
        classificationsParams,
        TYPEFACES_MULTI_MENU_ITEMS
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TypefaceHeader_module_default()).TypefaceHeader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TypefaceHeader_module_default()).bar,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TypefaceHeader_module_default()).filtering,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                        items: TYPEFACES_FILTERING_CATEGORIES,
                        defaultValue: TYPEFACES_FILTERING_CATEGORIES.find(function(category) {
                            return category.value === sort;
                        }),
                        onSelect: function(e) {
                            var ref, ref7, ref8, ref9;
                            setSort(e.value);
                            router.push({
                                pathname: "/typefaces",
                                query: TypefaceHeader_objectSpread({
                                    sort: "".concat((ref = e.value) === null || ref === void 0 ? void 0 : (ref7 = ref.field) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase(), ":").concat((ref8 = e.value) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.direction) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase())
                                }, languagesParams && {
                                    languages: languagesParams
                                }, classificationsParams && {
                                    classifications: classificationsParams
                                }, searchParams && {
                                    search: searchParams
                                })
                            }, undefined, {
                                shallow: true
                            });
                            return e;
                        },
                        size: "small",
                        align: "left",
                        fullWidth: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiDropdown/* default */.Z, {
                        items: TYPEFACES_MULTI_MENU_ITEMS,
                        title: "Filter",
                        onSelect: function(e) {
                            setMenuFilters(e);
                            return e;
                        },
                        size: "small",
                        align: "left",
                        selectedFiltersIds: selectedFiltersIds,
                        setMenuFilters: setMenuFilters,
                        fullWidth: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TypefaceHeader_module_default()).searchCont,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_SearchBox, {
                        state: searchState,
                        disabled: isComparing,
                        onSearch: function(param) {
                            var value = param.value;
                            applyFilters({
                                filters: filters,
                                type: "search",
                                value: value,
                                callback: setFilters
                            });
                            router.push({
                                pathname: "/typefaces",
                                query: TypefaceHeader_objectSpread({}, sortParams && {
                                    sort: sortParams
                                }, languagesParams && {
                                    languages: languagesParams
                                }, classificationsParams && {
                                    classifications: classificationsParams
                                }, {
                                    search: value
                                })
                            }, undefined, {
                                shallow: true
                            });
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/typeface/TypefaceCollection.tsx
function TypefaceCollection_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TypefaceCollection_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TypefaceCollection_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return TypefaceCollection_arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function TypefaceCollection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TypefaceCollection_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function TypefaceCollection_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function TypefaceCollection_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TypefaceCollection_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TypefaceCollection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TypefaceCollection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TypefaceCollection_slicedToArray(arr, i) {
    return TypefaceCollection_arrayWithHoles(arr) || TypefaceCollection_iterableToArrayLimit(arr, i) || TypefaceCollection_unsupportedIterableToArray(arr, i) || TypefaceCollection_nonIterableRest();
}
function TypefaceCollection_toConsumableArray(arr) {
    return TypefaceCollection_arrayWithoutHoles(arr) || TypefaceCollection_iterableToArray(arr) || TypefaceCollection_unsupportedIterableToArray(arr) || TypefaceCollection_nonIterableSpread();
}
function TypefaceCollection_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TypefaceCollection_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TypefaceCollection_arrayLikeToArray(o, minLen);
}

















var TypefaceCollection = function(param) {
    var categoryId = param.categoryId, _allowMore = param.allowMore, allowMore = _allowMore === void 0 ? true : _allowMore, serverProductsData = param.serverProductsData, childCategories = param.childCategories, attributes = param.attributes;
    var ref12, ref1;
    var t = (0,useIntl/* default */.Z)();
    var query = (0,RegionsProvider/* useRegions */.eH)().query;
    var ref2 = (0,react.useState)(""), customText = ref2[0], setCustomText = ref2[1];
    var ref3 = (0,react.useState)(false), paginationLoading = ref3[0], setPaginationLoading = ref3[1];
    var ref4 = (0,react.useState)([]), compareProducts = ref4[0], setCompareProducts = ref4[1];
    var ref5 = (0,react.useState)(), productData = ref5[0], setProductData = ref5[1];
    var ref6 = (0,react.useState)(false), viewComparedProducts = ref6[0], setViewComparedProducts = ref6[1];
    var searchState = (0,react.useState)("");
    var _searchState = TypefaceCollection_slicedToArray(searchState, 1), search = _searchState[0];
    var ref7 = (0,react.useState)({
        categories: [
            categoryId
        ],
        attributes: null
    }), filters = ref7[0], setFilters = ref7[1];
    var ref8 = (0,react.useState)(TYPEFACES_FILTERING_CATEGORIES[0].value), sort = ref8[0], setSort = ref8[1];
    var productRenderData = (0,react.useCallback)(function() {
        return productData ? productData : serverProductsData;
    }, [
        serverProductsData,
        productData
    ]);
    var ref9 = TypefaceCollection_slicedToArray((0,api/* useTypefaceCollectionLazyQuery */.oHg)({
        fetchPolicy: "cache-and-network",
        onCompleted: function(result) {
            var ref, ref11;
            var newProductData = {
                pageInfo: result === null || result === void 0 ? void 0 : (ref = result.products) === null || ref === void 0 ? void 0 : ref.pageInfo,
                totalCount: result === null || result === void 0 ? void 0 : (ref11 = result.products) === null || ref11 === void 0 ? void 0 : ref11.totalCount,
                edges: TypefaceCollection_toConsumableArray(productRenderData().edges).concat(TypefaceCollection_toConsumableArray(result === null || result === void 0 ? void 0 : result.products.edges))
            };
            setProductData(paginationLoading ? newProductData : result === null || result === void 0 ? void 0 : result.products);
        }
    }), 2), getProducts = ref9[0], ref10 = ref9[1], loading = ref10.loading, fetchMore = ref10.fetchMore, data = ref10.data;
    (0,react.useEffect)(function() {
        if (compareProducts.length < 2) {
            setViewComparedProducts(false);
        }
    }, [
        compareProducts
    ]);
    (0,react.useMemo)(function() {
        getProducts({
            variables: TypefaceCollection_objectSpread({
                sort: sort,
                filter: filters,
                after: null,
                first: 9
            }, query)
        });
    }, [
        filters,
        sort
    ]);
    var onLoadMore = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(cursor) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!loading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setPaginationLoading(true);
                        _ctx.next = 5;
                        return getProducts({
                            variables: TypefaceCollection_objectSpread({
                                sort: sort,
                                filter: filters,
                                first: 10,
                                after: cursor
                            }, query)
                        });
                    case 5:
                        setPaginationLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onLoadMore(cursor) {
            return _ref.apply(this, arguments);
        };
    }();
    var products = (0,react.useMemo)(function() {
        var ref;
        return ((ref = productRenderData()) === null || ref === void 0 ? void 0 : ref.edges.map(function(edge) {
            return edge.node;
        })) || [];
    }, [
        productRenderData
    ]);
    var toggleCompareProduct = function(product) {
        var productInState = compareProducts.some(function(item) {
            return item === product;
        });
        var newCompareArray = productInState ? TypefaceCollection_toConsumableArray(compareProducts.filter(function(item) {
            return item !== product;
        })) : TypefaceCollection_toConsumableArray(compareProducts).concat([
            product
        ]);
        return setCompareProducts(newCompareArray);
    };
    var itemIsChecked = function(product) {
        return compareProducts.some(function(item) {
            return item === product;
        });
    };
    var renderProducts = viewComparedProducts ? products.filter(function(product) {
        return compareProducts.includes(product.id);
    }) : products;
    var productCount = viewComparedProducts ? renderProducts.length : (ref12 = productRenderData()) === null || ref12 === void 0 ? void 0 : ref12.totalCount;
    var listingsElementRef = (0,react.useCallback)(function(node) {
        if (node !== null && node.firstChild !== null && node.children.length > 1) {
            var firstElementHeight = node.firstChild.getBoundingClientRect().height || 300;
            var defaultElementHeight = node.children.length > 0 ? node.children[1].getBoundingClientRect().height : 225;
            var productCountUpToEven = 2 * Math.round((productCount - 1) / 2);
            var rowGap = productCountUpToEven / 2 * 24;
            document.documentElement.style.setProperty("--first-el-height", "".concat(firstElementHeight, "px"));
            document.documentElement.style.setProperty("--default-el-height", "".concat(defaultElementHeight, "px"));
            document.documentElement.style.setProperty("--typefacePage-height-mobile", "".concat(defaultElementHeight * productCount + firstElementHeight + rowGap, "px"));
            document.documentElement.style.setProperty("--typefacePage-height", "".concat(defaultElementHeight * (productCountUpToEven / 2) + firstElementHeight + rowGap, "px"));
        }
    }, [
        productCount
    ]);
    var containerRef = (0,react.useRef)();
    var TypefacesShell = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (TypefaceCollection_module_default()).TypefaceShell,
            children: TypefaceCollection_toConsumableArray(Array(productCount)).map(function(e, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TypefaceCollection_module_default()).TypefaceShell__Item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    ]
                }, i);
            })
        });
    };
    // Scroll to top on first render
    (0,react.useEffect)(function() {
        var ref;
        if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo(0, 0);
        // Remove the scroll restoration
        history.scrollRestoration = "manual";
    }, [
        containerRef
    ]);
    // add 'view_item_list' to the dataLayer
    (0,react.useEffect)(function() {
        checkout/* default.viewItemList */.Z.viewItemList(products, "typefaces");
    }, [
        products
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Column */.s, {
                sm: 12,
                md: 12,
                lg: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TypefaceHeader, {
                        childCategories: childCategories,
                        attributes: attributes,
                        categoryId: categoryId,
                        searchState: searchState,
                        isComparing: viewComparedProducts,
                        filters: filters,
                        setFilters: setFilters,
                        sort: sort,
                        setSort: setSort
                    }),
                    search.length > 0 && products.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults/* default */.Z, {
                        title: "No Results for your search",
                        text: t.formatMessage(translations/* messages.noProducts */.s.noProducts)
                    }),
                    search.length === 0 && products.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults/* default */.Z, {
                        title: "No Results",
                        text: t.formatMessage(translations/* messages.noProductsFiltered */.s.noProductsFiltered)
                    }),
                    products.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TypefaceCollection_module_default()).TypefaceCollectionWrapper,
                        children: [
                            !viewComparedProducts && !search && /*#__PURE__*/ (0,jsx_runtime.jsx)(TypefacesShell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                role: "list",
                                ref: listingsElementRef,
                                className: (0,clsx_m/* default */.Z)((TypefaceCollection_module_default()).TypefaceCollection, TypefaceCollection_defineProperty({}, (TypefaceCollection_module_default()).TypefaceCollectionFullWidth, viewComparedProducts)),
                                children: renderProducts.map(function(product, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (0,clsx_m/* default */.Z)((TypefaceCollection_module_default()).productLi, i === 0 && !viewComparedProducts && (TypefaceCollection_module_default()).productLiFirst),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypefaceCard_TypefaceCard, {
                                            toggleCompareProduct: toggleCompareProduct,
                                            product: product,
                                            customText: customText,
                                            checked: itemIsChecked(product.id)
                                        }, product.id)
                                    }, product.id);
                                })
                            }),
                            allowMore && !viewComparedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                                onLoadMore: onLoadMore,
                                pageInfo: data === null || data === void 0 ? void 0 : (ref1 = data.products) === null || ref1 === void 0 ? void 0 : ref1.pageInfo,
                                loadOnScroll: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TypefaceCollection_module_default()).floatingCustomText,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    maxLength: 50,
                                    type: "text",
                                    placeholder: "Your text...",
                                    onChange: function(e) {
                                        setCustomText(e.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    callBack: function() {
                                        setViewComparedProducts(!viewComparedProducts);
                                    },
                                    variant: "primary",
                                    disabled: compareProducts.length < 2,
                                    muted: compareProducts.length < 2,
                                    children: !viewComparedProducts ? "Compare" : "Clear"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var typeface_TypefaceCollection = (TypefaceCollection);

// EXTERNAL MODULE: ./lib/storyblok/storyblokNavLinks.ts
var storyblokNavLinks = __webpack_require__(83176);
;// CONCATENATED MODULE: ./pages/typefaces/index.tsx









var TypefacePage = function(param) {
    var category = param.category, story = param.story, preview = param.preview, products = param.products, attributes = param.attributes, resolve_relations = param.resolve_relations;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var sbStory = preview ? (0,storyblok/* useStoryblok */.P)(story, preview, resolve_relations) : story;
    var _content = sbStory.content, _Fonts = _content.Fonts, Fonts = _Fonts === void 0 ? [] : _Fonts, _headerTheme = _content.headerTheme, headerTheme = _headerTheme === void 0 ? "" : _headerTheme, _SEO = _content.SEO, SEO = _SEO === void 0 ? {} : _SEO, pageTheme = _content.pageTheme, _name = sbStory.name, name = _name === void 0 ? "" : _name, full_slug = sbStory.full_slug;
    var globalLinks = (0,storyblokNavLinks/* getStoryBlokNavLinks */.G)(story);
    if (!category) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {
            story: null
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                blok: sbStory.content,
                navigation: globalLinks,
                hasBorder: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSeo/* BaseSeo */.t, {
                title: SEO === null || SEO === void 0 ? void 0 : SEO.title,
                description: (SEO === null || SEO === void 0 ? void 0 : SEO.description) || (category === null || category === void 0 ? void 0 : category.seoDescription),
                ogDescription: (SEO === null || SEO === void 0 ? void 0 : SEO.og_description) || (category === null || category === void 0 ? void 0 : category.seoDescription),
                ogTitle: (SEO === null || SEO === void 0 ? void 0 : SEO.og_title) || (category === null || category === void 0 ? void 0 : category.seoTitle),
                image: (SEO === null || SEO === void 0 ? void 0 : SEO.og_image) || null,
                path: full_slug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main",
                className: "page-padding-top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typeface_TypefaceCollection, {
                    childCategories: category.children.edges,
                    attributes: attributes,
                    categoryId: category === null || category === void 0 ? void 0 : category.id,
                    serverProductsData: products
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.ZP, {
                theme: "grey-light",
                navigation: globalLinks.footerLinks
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var typefaces = (TypefacePage);
TypefacePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Layout */.Ar, {
        children: page
    });
};


/***/ }),

/***/ 48941:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__U_Gbz","header":"styles_header__bStsl","text":"styles_text__Us7X2","button":"styles_button__HXpXL","containerImage":"styles_containerImage__jeLaT","textBlock":"styles_textBlock__M6L7u"};

/***/ }),

/***/ 39174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBox_search__dcPK7","icon":"SearchBox_icon__JHo9x","input":"SearchBox_input__ZW2_t","disabled":"SearchBox_disabled__44ZdT"};

/***/ }),

/***/ 88102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TypefaceCardContainer":"TypefaceCard_TypefaceCardContainer__ABZ_U","TypefaceCard":"TypefaceCard_TypefaceCard_____ZL","TypefaceCard__Details":"TypefaceCard_TypefaceCard__Details__VcbHd","TypefaceCard__StampInner":"TypefaceCard_TypefaceCard__StampInner__poTgK","TypefaceCard__FontTitle":"TypefaceCard_TypefaceCard__FontTitle__T7jLD","TypefaceCard__Details--single":"TypefaceCard_TypefaceCard__Details--single__pLEkt","TypefaceCard__Details--multi":"TypefaceCard_TypefaceCard__Details--multi__oWsPI","TypefaceCard__Stamp":"TypefaceCard_TypefaceCard__Stamp__pc8BE","compare":"TypefaceCard_compare__gW_Wm"};

/***/ }),

/***/ 53643:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TypefaceCollectionWrapper":"TypefaceCollection_TypefaceCollectionWrapper__K9x4y","TypefaceCollection":"TypefaceCollection_TypefaceCollection__KrOsW","TypefaceShell":"TypefaceCollection_TypefaceShell__GzYGi","productLi":"TypefaceCollection_productLi__NnQEp","productLiFirst":"TypefaceCollection_productLiFirst__gUzgP","TypefaceCollectionFullWidth":"TypefaceCollection_TypefaceCollectionFullWidth___cq_z","floatingCustomText":"TypefaceCollection_floatingCustomText__YZqWc","TypefaceShell__Item":"TypefaceCollection_TypefaceShell__Item__k_DD7","sk_bg_animation":"TypefaceCollection_sk_bg_animation__vukkU","noresults":"TypefaceCollection_noresults__PTSeR"};

/***/ }),

/***/ 6887:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TypefaceHeader":"TypefaceHeader_TypefaceHeader__vnphd","bar":"TypefaceHeader_bar__H06Uq","category":"TypefaceHeader_category__LxdNS","language":"TypefaceHeader_language__pG_aO","searchCont":"TypefaceHeader_searchCont__R0Mf4","disabled":"TypefaceHeader_disabled__p443N","filtering":"TypefaceHeader_filtering__vAfdM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7099,9370,8578,7715,7972,5568,9774,2888,179], function() { return __webpack_exec__(33736); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);